import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconMonitorBrightnessContrastProps } from './IconMonitorBrightnessContrast.types'
import * as Styled from './styles/IconMonitorBrightnessContrast.style'

import { nonThemeableRules } from '../../ruleSet'

const IconMonitorBrightnessContrast: FC<IconMonitorBrightnessContrastProps> = ({
  size = nonThemeableRules.defaultSize as number as IconMonitorBrightnessContrastProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconMonitorBrightnessContrastProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M21.477 12A9.476 9.476 0 0 1 12 21.477 9.476 9.476 0 0 1 2.523 12 9.476 9.476 0 0 1 12 2.523 9.476 9.476 0 0 1 21.477 12ZM12 4.055v1.988m-5.621.347 1.406 1.407M4.059 12.02h1.988m.351 5.62 1.407-1.406m4.218 3.726v-1.987m5.622-.352-1.407-1.406m3.727-4.223h-1.988m-.348-5.617-1.406 1.406'
            vectorEffect='non-scaling-stroke'
          />
          <path
            d='M15.922 12.008a3.909 3.909 0 1 1-7.817-.005 3.909 3.909 0 0 1 7.817.005Zm-3.91-3.906v7.812'
            vectorEffect='non-scaling-stroke'
          />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconMonitorBrightnessContrast
